import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL + "/api",
  // baseURL: `${"https://nasl.sartimsolutions.com"}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
